import {useAppContext} from "../../utils/AppContext";
import features from '../../assets/images/maze_features.png';
import {useState} from 'react';

const Benefits = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const {
        projectData,
        screenSize,
    } = useAppContext();

    // Styles Configuration //
    const benefitsContainer = (!screenSize)? 'benefits-container' : `benefits-container benefits-container${screenSize}`;
    const sectionTitle = (!screenSize)? 'section-title' : `section-title section-title${screenSize}`;
    const benefitsRowContainer = (!screenSize)? 'benefits-row-container' : `benefits-row-container benefits-row-container${screenSize}`;
    const benefitImage = (!screenSize)? 'benefit-image' : `benefit-image benefit-image${screenSize}`;
    const benefitContentContainer = (!screenSize)? 'benefit-content-container' : `benefit-content-container benefit-content-container${screenSize}`;
    const benefitContentItem = (!screenSize)? 'benefit-content-item' : `benefit-content-item benefit-content-item${screenSize}`;
    const benefitTitleButton = (!screenSize)? 'benefit-title-button' : `benefit-title-button benefit-title-button${screenSize}`;
    const itemTitle = (!screenSize)? 'item-title' : `item-title item-title${screenSize}`;
    const smallTextLight = (!screenSize)? 'small-text-light' : `small-text-light small-text-light${screenSize}`;

    const renderBenefitItem = ({item, index}) => (
        <div 
            className={benefitContentItem}
            key={index}>
            <button
                className={benefitTitleButton}
                onClick={() => setActiveIndex(index)}
            >
                <h4 className={itemTitle}>{item.title}</h4>
            </button>
            {(activeIndex !== null && activeIndex === index) && (
                <p className={smallTextLight}>{item.description}</p>
            )}
        </div>
    );

    return (
        <div className={benefitsContainer}>
            <h2 className={sectionTitle}>{projectData.features.title}</h2>
            <div className={benefitsRowContainer}>
                <img
                    className={benefitImage}
                    src={features}
                    alt="maze features"
                />
                <div className={benefitContentContainer}>
                    {projectData.features.items.map((item, index) => (
                        renderBenefitItem({item, index})
                    ))}
                </div>
            </div>
        </div>
    );

};

export default Benefits;
